module.exports = __webpack_public_path__ + "img/icon-swipe-right-empty.2cf604a.svg";